import { render, staticRenderFns } from "./HeartysanChatSection.vue?vue&type=template&id=fdd81594&scoped=true"
import script from "./HeartysanChatSection.vue?vue&type=script&lang=js"
export * from "./HeartysanChatSection.vue?vue&type=script&lang=js"
import style0 from "./HeartysanChatSection.vue?vue&type=style&index=0&id=fdd81594&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd81594",
  null
  
)

export default component.exports